import React from 'react';
import { BaseField } from 'react/components/fields';
import PropTypes from 'prop-types';
import CrudContext from 'react/contexts/DefaultContext';

class TimeField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      monetField: null
    };
  }

  componentDidMount() {
    const {
      name,
      type,
      hourMax,
      hourGrid,
      showButtonPanel,
      stepHour,
      hour,
      minuteGrid,
      showTime,
    } = this.props;
    const meta = {
      hourMax,
      hourGrid,
      minuteGrid,
      stepHour,
      showButtonPanel,
      showTime,
      hour
    };

    const { entity } = this.context;
    const monetField = new Monet.UI.Fields.Render(
      {
        name: name.replace(/\[|\]|\./g, ''),
        type,
        meta
      },
      entity
    ).render();

    this.setState({
      monetField
    });
  }

  customValidation = (values) => {
    const { required, hourMax } = this.props;
    const hourMaxInSeconds = hourMax * 60 * 60;
    if (required && !values) {
      return 'general.mandatoryField';
    }
    if (values && values > hourMaxInSeconds) {
      return `${Monet.I18n.getResourcesByKey('general.integerField.errorMax', hourMax).replace('.', '')} ${Monet.I18n.getResourcesByKey('Greenmile.DataImport.hours')}.`;
    }
    return undefined;
  };

  gridFormatter = () => {
    const { label, name } = this.props;

    return {
      id: name,
      name,
      label
    };
  };

  renderFieldContent = ({ input, monetField, ref, disabled }) => {
    if (monetField) {
      const onChange = () => {
        const value = monetField.getValue();
        input.onChange(value);
      };

      monetField.setValue(input.value);

      if (disabled) {
        monetField.disable();
      }

      monetField.input.onchange = onChange;
    }
    return <div ref={ref} />;
  };

  render() {
    const { monetField } = this.state;
    return (
      <BaseField
        fieldClassName="timeField"
        monetField={monetField}
        renderFieldContent={this.renderFieldContent}
        customValidation={this.customValidation}
        gridFormatter={this.gridFormatter}
        {...this.props}
      />
    );
  }
}

TimeField.contextType = CrudContext;

TimeField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  hourMax: PropTypes.number,
  hourGrid: PropTypes.number,
  minuteGrid: PropTypes.number,
  showTime: PropTypes.bool,
  showButtonPanel: PropTypes.bool,
  hour: PropTypes.number,
  stepHour: PropTypes.number
};

TimeField.defaultProps = {
  type: 'TIME_HOURS_SECONDS',
  disabled: false,
  required: false,
  hourMax: 23,
  hourGrid: 4,
  minuteGrid: 10,
  showButtonPanel: true,
  hour: 1,
  stepHour: 1,
  showTime: true,
};

export default TimeField;
